<template>
  <div>
    <Counting_stock_count/>
  </div>
</template>

<script>
import Counting_stock_count from "@/components/adminArin/pos_system/warehouse/countingstock/Counting_stock_count";
export default {
  name: "countingstockcount",
  components: {
    Counting_stock_count
  }
}
</script>

<style scoped>

</style>
